export default __webpack_public_path__ + "static/media/websites_compilation.167e10d8.gif";